'use strict';
app.factory('checkrollService', function ($rootScope) {

    //Why need this?
    //Before approval, we need to populate the data into grid first
    //This applies to either approve from backend, or from quarto
    //Eg: Worker W1, Block B1 and B2, Rate Type R1
    //There would be 2 records. But MD is 1, as there is only 1 Det
    //Assume ismapa flag already factor in during query
    const formatQCHarvestingDataToQuartoDS = (detailsGroupByDateGang, OUKey) => {
        const _ffbhdet = [];
        const _ffbhblkdet = [];
        detailsGroupByDateGang.forEach((_val, _ind) => {
            const { EmpyKey, EmpyCode, EmpyCodeEmpyDesc, HarvestingIds, Ripe, Others, PayBunches, HarRate, TaskCode, BlockTaskKey, 
                BlockKey, BlockCode, EnableConvRate, EnableMacRate, EnableTallPalm, WrkDayType, RateTypeCode, Bunches = 0 } = _val;
            let indexEmpy = _.findIndex(_ffbhdet, (b) => b.EmpyKey == EmpyKey);

            //Handle if QC input different Rate type for a worker and block 
            //Need user himself to fix this issue
            const needNewRow = indexEmpy !== -1 && _ffbhblkdet.some(p => p.EmpyKey === EmpyKey && p.BlockKey === BlockKey && (p.RateTypeCode !== RateTypeCode || p.WrkDayType !== WrkDayType || p.BlockTaskKey !== BlockTaskKey));
            const seqNo = (indexEmpy === -1 || needNewRow) ? _ffbhdet.length + 1 : _ffbhdet[indexEmpy].SeqNo;
            if (indexEmpy === -1 || needNewRow) {
                const empyDetails = {
                    FFBHarDetKey: 0,
                    FFBHarHdrKey: 0,
                    ClientKey: 0,
                    OUKey,
                    EmpyKey: EmpyKey,
                    EmpyID: EmpyCode,
                    EmpyIDEmpyName: EmpyCodeEmpyDesc,
                    MD: 1,
                    SeqNo: seqNo,
                    RowState: $rootScope.RowState.Added,
                    IsSelect: false,
                    WrkDayType: WrkDayType
                };
                _ffbhdet.push(empyDetails);
                indexEmpy = _ffbhdet.length - 1;
            }
            const harBlkDet = {
                FFBHarBlkDetKey: 0,
                FFBHarDetKey: 0,
                MblHarvId: HarvestingIds,
                EmpyKey,
                Ripe,
                Others,
                Penalty: 0,
                PayableBch: PayBunches,
                PayableWt: 0,
                Rate: HarRate,
                RateTypeCode,
                RateType: RateTypeCode, //for approval without opening form
                GrossAmt: 0,
                Productivity: 0,
                PenaltyAmt: 0,
                BlockKey,
                SeqNo: seqNo,
                FFBHarHdrKey: 0,
                BlockCode,
                EnableConvRate,
                EnableMacRate,
                EnableTallPalm,
                HarRate,
                Bunches: PayBunches,
                RowState: $rootScope.RowState.Added,
                BlockTaskKey,
                TaskCode,
                WrkDayType
            }
            _ffbhblkdet.push(harBlkDet);

            //update employee block's harvesting details
            _ffbhdet[indexEmpy]["BlockTaskKey" + harBlkDet.BlockKey] = harBlkDet.BlockTaskKey;
            _ffbhdet[indexEmpy]["TaskCode" + harBlkDet.BlockKey] = harBlkDet.TaskCode;
            _ffbhdet[indexEmpy]["MBL" + harBlkDet.BlockKey] = harBlkDet.MblHarvId;
            _ffbhdet[indexEmpy]["R" + harBlkDet.BlockKey] = harBlkDet.Ripe;
            _ffbhdet[indexEmpy]["O" + harBlkDet.BlockKey] = harBlkDet.Others;
            _ffbhdet[indexEmpy]["P" + harBlkDet.BlockKey] = harBlkDet.Penalty;
            _ffbhdet[indexEmpy]["PB" + harBlkDet.BlockKey] = harBlkDet.PayableBch;
            _ffbhdet[indexEmpy]["Rate" + harBlkDet.BlockKey] = harBlkDet.Rate;
            _ffbhdet[indexEmpy]["RateType" + harBlkDet.BlockKey] = harBlkDet.RateTypeCode;
        });

        //Update the MD afterwards (due to unable to populate MD while forming the grid data)
        const mdOne = 1;
        _ffbhdet.forEach((a, _ind) => {
            const totalThisEmpyCount = _ffbhdet.filter(b => b.EmpyKey === a.EmpyKey).length;
            const isLastEmpyInListOfHim = _ind === _ffbhdet.map((b, dInd) => ({ EmpyKey: b.EmpyKey, dInd })).filter(b => b.EmpyKey === a.EmpyKey).at(-1).dInd;
            if (totalThisEmpyCount > 10) {
                const positionForThisEmpy = _ffbhdet.map((b, dInd) => ({ EmpyKey: b.EmpyKey, dInd })).filter(b => b.EmpyKey === a.EmpyKey).findIndex(b => b.dInd === _ind);
                a.MD = positionForThisEmpy >= 10 ? 0 : 0.1;
            } else {
                const mdEach = parseFloat((mdOne.NdividedBy(totalThisEmpyCount)).toFixed(1));
                a.MD = isLastEmpyInListOfHim ? (mdOne.Nminus((totalThisEmpyCount.Nminus(1)).Ntimes(mdEach))) : mdEach;
            }
        });

        return [ _ffbhdet, _ffbhblkdet ];
    }

    const formatQCHarvestingInterOUDataToQuartoDS = (detailsGroupByDateGang, OUKey) => {
        const _ffbhdet = [];
        const _ffbhblkdet = [];

        detailsGroupByDateGang.forEach((_val, _ind) => {
            const { EmpyKey, EmpyCode, EmpyCodeEmpyDesc, HarvestingIds, Ripe, Others, PayBunches, HarRate, TaskCode, BlockTaskKey, 
                BlockKey, BlockCode, EnableConvRate, EnableMacRate, EnableTallPalm, WrkDayType, RateTypeCode, EnableHRPro } = _val;
            let indexEmpy = _.findIndex(_ffbhdet, (b) => b.EmpyKey == EmpyKey);

            //Handle if QC input different Rate type for a worker and block 
            //Need user himself to fix this issue
            const needNewRow = indexEmpy !== -1 && _ffbhblkdet.some(p => p.EmpyKey === EmpyKey && p.BlockKey === BlockKey && (p.RateTypeCode !== RateTypeCode || p.WrkDayType !== WrkDayType || p.BlockTaskKey !== BlockTaskKey));
            const seqNo = (indexEmpy === -1 || needNewRow) ? _ffbhdet.length + 1 : _ffbhdet[indexEmpy].SeqNo;

            if (indexEmpy === -1 || needNewRow) {
                const empyDetails = {
                    FFBHarDetKey: 0,
                    FFBHarHdrKey: 0,
                    ClientKey: 0,
                    OUKey,
                    EmpyKey: EmpyKey,
                    EmpyID: EmpyCode,
                    EmpyIDEmpyName: EmpyCodeEmpyDesc,
                    MD: 1,
                    SeqNo: seqNo,
                    RowState: $rootScope.RowState.Added,
                    IsSelect: false,
                    WrkDayType: WrkDayType                 
                };
                _ffbhdet.push(empyDetails);
                indexEmpy = _ffbhdet.length - 1;
            }
            const harBlkDet = {
                FFBHarBlkDetKey: 0,
                FFBHarDetKey: 0,
                MblHarvId: HarvestingIds,
                EmpyKey,
                Ripe,
                Others,
                Penalty: 0,
                PayableBch: PayBunches,
                PayableWt: 0,
                Rate: HarRate,
                RateTypeCode,
                RateType: RateTypeCode, //for approval without opening form
                GrossAmt: 0,
                Productivity: 0,
                PenaltyAmt: 0,
                BlockKey,
                SeqNo: seqNo,
                FFBHarHdrKey: 0,
                BlockCode,
                EnableConvRate,
                EnableMacRate,
                EnableTallPalm,
                EnableHRPro,
                HarRate,
                RowState: $rootScope.RowState.Added,
                BlockTaskKey,
                TaskCode,
                WrkDayType
            }
            _ffbhblkdet.push(harBlkDet);

            //update employee block's harvesting details
            _ffbhdet[indexEmpy]["BlockTaskKey" + harBlkDet.BlockKey] = harBlkDet.BlockTaskKey;
            _ffbhdet[indexEmpy]["TaskCode" + harBlkDet.BlockKey] = harBlkDet.TaskCode;
            _ffbhdet[indexEmpy]["MBL" + harBlkDet.BlockKey] = harBlkDet.MblHarvId;
            _ffbhdet[indexEmpy]["R" + harBlkDet.BlockKey] = harBlkDet.Ripe;
            _ffbhdet[indexEmpy]["O" + harBlkDet.BlockKey] = harBlkDet.Others;
            _ffbhdet[indexEmpy]["P" + harBlkDet.BlockKey] = harBlkDet.Penalty;
            _ffbhdet[indexEmpy]["PB" + harBlkDet.BlockKey] = harBlkDet.PayableBch;
            _ffbhdet[indexEmpy]["Rate" + harBlkDet.BlockKey] = harBlkDet.Rate;
            _ffbhdet[indexEmpy]["RateType" + harBlkDet.BlockKey] = harBlkDet.RateTypeCode;
        });

        //Update the MD afterwards (due to unable to populate MD while forming the grid data)
        const mdOne = 1;
        _ffbhdet.forEach((a, _ind) => {
            const totalThisEmpyCount = _ffbhdet.filter(b => b.EmpyKey === a.EmpyKey).length;
            const isLastEmpyInListOfHim = _ind === _ffbhdet.map((b, dInd) => ({ EmpyKey: b.EmpyKey, dInd })).filter(b => b.EmpyKey === a.EmpyKey).at(-1).dInd;
            if (totalThisEmpyCount > 10) {
                const positionForThisEmpy = _ffbhdet.map((b, dInd) => ({ EmpyKey: b.EmpyKey, dInd })).filter(b => b.EmpyKey === a.EmpyKey).findIndex(b => b.dInd === _ind);
                a.MD = positionForThisEmpy >= 10 ? 0 : 0.1;
            } else {
                const mdEach = parseFloat((mdOne.NdividedBy(totalThisEmpyCount)).toFixed(1));
                a.MD = isLastEmpyInListOfHim ? (mdOne.Nminus((totalThisEmpyCount.Nminus(1)).Ntimes(mdEach))) : mdEach;
            }
        });

        return [_ffbhdet, _ffbhblkdet];
    };

    const formatQCHarvestingDataToQuartoDS_IND = (detailsGroupByDateGang, cropPenaltyByDateGang, OUKey) => {
        try {
            const _ffbhdet = [];
            const _ffbhblkdet = [];
            detailsGroupByDateGang.forEach((_val, _ind) => {
                const { EmpyKey, EmpyCode, EmpyCodeEmpyDesc, HarvestingIds, Ripe, Others, PayBunches, HarRate,
                    BlockKey, BlockCode, EnableConvRate, EnableMacRate, EnableTallPalm, LF, PenaltyAmount, BlockTaskKey, TaskCode } = _val;
                let indexEmpy = _.findIndex(_ffbhdet, (b) => b.EmpyKey == EmpyKey);

                const needNewRow = indexEmpy !== -1 && _ffbhblkdet.some(p => p.EmpyKey === EmpyKey && p.BlockKey === BlockKey && p.BlockTaskKey !== BlockTaskKey);
                const seqNo = (indexEmpy === -1 || needNewRow) ? _ffbhdet.length + 1 : _ffbhdet[indexEmpy].SeqNo;
                if (indexEmpy === -1 || needNewRow) {
                    const empyDetails = {
                        FFBHarDetKey: 0,
                        FFBHarHdrKey: 0,
                        ClientKey: 0,
                        OUKey,
                        EmpyKey,
                        EmpyID: EmpyCode,
                        EmpyIDEmpyName: EmpyCodeEmpyDesc,
                        MD: 1,
                        SeqNo: seqNo,
                        RowState: $rootScope.RowState.Added,
                        IsSelect: false
                    };
                    _ffbhdet.push(empyDetails);
                    indexEmpy = _ffbhdet.length - 1;
                }
                const harBlkDet = {
                    FFBHarBlkDetKey: 0,
                    FFBHarDetKey: 0,
                    MblHarvId: HarvestingIds,
                    EmpyKey,
                    Ripe,
                    Others,
                    PayableBch: PayBunches,
                    PayableWt: 0,
                    Rate: HarRate,
                    GrossAmt: 0,
                    Productivity: 0,
                    Penalty: PenaltyAmount, //at blkdet level, column name is Penalty
                    BlockKey,
                    FFBHarHdrKey: 0,
                    BlockCode,
                    EnableConvRate,
                    EnableMacRate,
                    EnableTallPalm,
                    HarRate,
                    Bunches: PayBunches,
                    LF,
                    BlockTaskKey,
                    TaskCode,
                    SeqNo: seqNo,
                    RowState: $rootScope.RowState.Added
                }
                _ffbhblkdet.push(harBlkDet);

                //update employee block's harvesting details
                _ffbhdet[indexEmpy]["MBL" + harBlkDet.BlockKey] = harBlkDet.MblHarvId;
                _ffbhdet[indexEmpy]["BlockTaskKey" + harBlkDet.BlockKey] = harBlkDet.BlockTaskKey;
                _ffbhdet[indexEmpy]["TaskCode" + harBlkDet.BlockKey] = harBlkDet.TaskCode;
                _ffbhdet[indexEmpy]["R" + harBlkDet.BlockKey] = harBlkDet.Ripe;
                _ffbhdet[indexEmpy]["O" + harBlkDet.BlockKey] = harBlkDet.Others;
                _ffbhdet[indexEmpy]["P" + harBlkDet.BlockKey] = 0; //P stands for premium, not penalty
                _ffbhdet[indexEmpy]["PB" + harBlkDet.BlockKey] = harBlkDet.PayableBch;
                _ffbhdet[indexEmpy]["Rate" + harBlkDet.BlockKey] = harBlkDet.Rate;
                _ffbhdet[indexEmpy]["A" + harBlkDet.BlockKey] = harBlkDet.Penalty;
                _ffbhdet[indexEmpy]["L" + harBlkDet.BlockKey] = harBlkDet.LF;
            });

            //Update the MD afterwards (due to unable to populate MD while forming the grid data)
            const mdOne = 1;
            _ffbhdet.forEach((a, _ind) => {
                const totalThisEmpyCount = _ffbhdet.filter(b => b.EmpyKey === a.EmpyKey).length;
                const mdEach = parseFloat((mdOne.NdividedBy(totalThisEmpyCount)).toFixed(1));
                const isLastEmpyInListOfHim = _ind === _ffbhdet.map((b, dInd) => ({ EmpyKey: b.EmpyKey, dInd })).filter(b => b.EmpyKey === a.EmpyKey).at(-1).dInd;
                a.MD = isLastEmpyInListOfHim ? (mdOne.Nminus((totalThisEmpyCount.Nminus(1)).Ntimes(mdEach))) : mdEach;
            });

            const _ffbhpenaltydet = cropPenaltyByDateGang.map(a => {
                //pair each penalty with its block/task row so SeqNo matches the corresponding ffbhblkdet on save
                const matchingBlk = _ffbhblkdet.find(b => b.EmpyKey === a.EmpyKey && b.BlockKey === a.BlockKey && b.BlockTaskKey === a.BlockTaskKey);
                a.SeqNo = matchingBlk ? matchingBlk.SeqNo : 0;
                a.RowState = $rootScope.RowState.Added;
                return a;
            });;

            return [_ffbhdet, _ffbhblkdet, _ffbhpenaltydet];
        }
        catch (ex) {
            console.error(ex);
        }
    }

    const formatQCHarvestingInterOUDataToQuartoDS_IND = (detailsGroupByDateGang, cropPenaltyByDateGang, OUKey) => {
        try {
            const _ffbhdet = [];
            const _ffbhblkdet = [];
            detailsGroupByDateGang.forEach((_val, _ind) => {
                const { EmpyKey, EmpyCode, EmpyCodeEmpyDesc, HarvestingIds, Ripe, Others, PayBunches, HarRate,
                    BlockKey, BlockCode, EnableConvRate, EnableMacRate, EnableTallPalm, LF, PenaltyAmount, BlockTaskKey, TaskCode } = _val;
                let indexEmpy = _.findIndex(_ffbhdet, (b) => b.EmpyKey == EmpyKey);

                const needNewRow = indexEmpy !== -1 && _ffbhblkdet.some(p => p.EmpyKey === EmpyKey && p.BlockKey === BlockKey && p.BlockTaskKey !== BlockTaskKey);
                const seqNo = (indexEmpy === -1 || needNewRow) ? _ffbhdet.length + 1 : _ffbhdet[indexEmpy].SeqNo;
                if (indexEmpy === -1 || needNewRow) {
                    const empyDetails = {
                        FFBHarDetKey: 0,
                        FFBHarHdrKey: 0,
                        ClientKey: 0,
                        OUKey,
                        EmpyKey,
                        EmpyID: EmpyCode,
                        EmpyIDEmpyName: EmpyCodeEmpyDesc,
                        MD: 1,
                        SeqNo: seqNo,
                        RowState: $rootScope.RowState.Added,
                        IsSelect: false
                    };
                    _ffbhdet.push(empyDetails);
                    indexEmpy = _ffbhdet.length - 1;
                }
                const harBlkDet = {
                    FFBHarBlkDetKey: 0,
                    FFBHarDetKey: 0,
                    MblHarvId: HarvestingIds,
                    EmpyKey,
                    Ripe,
                    Others,
                    PayableBch: PayBunches,
                    PayableWt: 0,
                    Rate: HarRate,
                    GrossAmt: 0,
                    Productivity: 0,
                    Penalty: PenaltyAmount, //at blkdet level, column name is Penalty
                    BlockKey,
                    FFBHarHdrKey: 0,
                    BlockCode,
                    EnableConvRate,
                    EnableMacRate,
                    EnableTallPalm,
                    HarRate,
                    Bunches: PayBunches,
                    LF,
                    BlockTaskKey,
                    TaskCode,
                    SeqNo: seqNo,
                    RowState: $rootScope.RowState.Added
                }
                _ffbhblkdet.push(harBlkDet);

                //update employee block's harvesting details
                _ffbhdet[indexEmpy]["MBL" + harBlkDet.BlockKey] = harBlkDet.MblHarvId;
                _ffbhdet[indexEmpy]["BlockTaskKey" + harBlkDet.BlockKey] = harBlkDet.BlockTaskKey;
                _ffbhdet[indexEmpy]["TaskCode" + harBlkDet.BlockKey] = harBlkDet.TaskCode;
                _ffbhdet[indexEmpy]["R" + harBlkDet.BlockKey] = harBlkDet.Ripe;
                _ffbhdet[indexEmpy]["O" + harBlkDet.BlockKey] = harBlkDet.Others;
                _ffbhdet[indexEmpy]["P" + harBlkDet.BlockKey] = 0;
                _ffbhdet[indexEmpy]["PB" + harBlkDet.BlockKey] = harBlkDet.PayableBch;
                _ffbhdet[indexEmpy]["Rate" + harBlkDet.BlockKey] = harBlkDet.Rate;
                _ffbhdet[indexEmpy]["A" + harBlkDet.BlockKey] = harBlkDet.Penalty;
                _ffbhdet[indexEmpy]["L" + harBlkDet.BlockKey] = harBlkDet.LF;
            });

            //Update the MD afterwards (due to unable to populate MD while forming the grid data)
            const mdOne = 1;
            _ffbhdet.forEach((a, _ind) => {
                const totalThisEmpyCount = _ffbhdet.filter(b => b.EmpyKey === a.EmpyKey).length;
                const mdEach = parseFloat((mdOne.NdividedBy(totalThisEmpyCount)).toFixed(1));
                const isLastEmpyInListOfHim = _ind === _ffbhdet.map((b, dInd) => ({ EmpyKey: b.EmpyKey, dInd })).filter(b => b.EmpyKey === a.EmpyKey).at(-1).dInd;
                a.MD = isLastEmpyInListOfHim ? (mdOne.Nminus((totalThisEmpyCount.Nminus(1)).Ntimes(mdEach))) : mdEach;
            });

            const _ffbhpenaltydet = cropPenaltyByDateGang.map(a => {
                //pair each penalty with its block/task row so SeqNo matches the corresponding ffbhblkdet on save
                const matchingBlk = _ffbhblkdet.find(b => b.EmpyKey === a.EmpyKey && b.BlockKey === a.BlockKey && b.BlockTaskKey === a.BlockTaskKey);
                a.SeqNo = matchingBlk ? matchingBlk.SeqNo : 0;
                a.RowState = $rootScope.RowState.Added;
                return a;
            });;

            return [_ffbhdet, _ffbhblkdet, _ffbhpenaltydet];
        }
        catch (ex) {
            console.error(ex);
        }
    }


    return {
        formatQCHarvestingDataToQuartoDS,
        formatQCHarvestingInterOUDataToQuartoDS,
        formatQCHarvestingDataToQuartoDS_IND,
        formatQCHarvestingInterOUDataToQuartoDS_IND
    }
});